import type { FC } from "react";
import React, { useEffect } from "react";
import {
  useCookieStore,
  useDatalayerTracking,
  useTracking,
} from "@edreamsodigeo/frontend-core";

import useUserAccount from "~/clientState/hooks/useUserAccount";

const PrimeUserTracking: FC = () => {
  const { data } = useUserAccount();
  const { save: saveDatalayer } = useDatalayerTracking();
  const { setCustomDimension } = useTracking();
  const cookieStore = useCookieStore();

  const { userAccount } = data || {};
  const { userMembership } = userAccount || {};

  useEffect(() => {
    if (!userAccount || !userMembership) {
      return;
    }
    const { isLoggedIn } = userAccount;
    const { isActive, subscriptionDetails } = userMembership;

    const { isFreeTrial, currentPlanDetails } = subscriptionDetails || {};
    const { tier } = currentPlanDetails || {};

    const COOKIE_NAME = "ua_dimension31";
    const hasCookieSubscriber = cookieStore.get(COOKIE_NAME) === "subscriber";

    const subscription =
      isActive || hasCookieSubscriber ? "subscriber" : "non-subscriber";
    const subscriptionType = isFreeTrial ? "free-trial" : "paid-prime";
    const subscriptionGroup = isActive
      ? `${subscriptionType}-${tier?.toLowerCase()}`
      : "not-apply";

    saveDatalayer({
      user_sso_login: isLoggedIn ? `logged_in` : `logged_out`,
      /** @deprecated use subscription + subscription_status instead */
      user_prime_subscription: subscription,
      subscription,
      /** @deprecated use subscription_group + subscription_permitted instead */
      user_prime_subscription_type: subscriptionGroup,
      subscription_group: subscriptionGroup,
    });

    setCustomDimension({
      sso_hit: isLoggedIn ? "SSO_1" : "SSO_0",
      /** @deprecated use subscription + subscription_status instead */
      unlocked_subscription: subscription,
      subscription,
      /** @deprecated use subscription_group + subscription_permitted instead */
      subscription_type: subscriptionGroup,
      subscription_group: subscriptionGroup,
    });
  }, [
    userAccount,
    userMembership,
    saveDatalayer,
    setCustomDimension,
    cookieStore,
  ]);

  return <></>;
};

export default PrimeUserTracking;
